import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WizardNavigation from '../WizardNavigation';
import { useTranslation } from 'react-i18next';
import * as actions from '../../../store/actions/index';
import WizardButton from '../WizardButton';
import Aux from '../../../hoc/Aux';
import WizardStandardHeader from '../WizardStandardHeader';
import WizardStandardSubHeader from '../WizardStandardSubHeader';
import WizardProductSystemImageCard from '../WizardProductSystemImageCard';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import Select from 'react-select'
import { useForm, Controller } from "react-hook-form";
import { currentLang } from '../../../store/actions/support';

const wizardStepProductSystem = (props) => {

  if (props.currentStep !== 'product_system') {
    return null;
  }

  const { t } = useTranslation();
  const [buttons, setButtons] = useState([]);
  const { width } = useWindowDimensions();

  // select

  const [penetrationRawData, setPenetrationRawData] = useState([]);
  const [filteredProductSystemIds, setFilteredProductSystemIds] = useState([]);

  const { control } = useForm();

  // multiSelect Durchführungen 
  const [penetrationOptions, setPenetrationOptions] = useState([]);
  const [selectedPenetration, setSelectedPenetration] = useState([]);

  const [insulationOptions, setInsulationOptions] = useState([]);
  const [selectedInsulation, setSelectedInsulation] = useState([]);

  const [productOptions, setProductOptions] = useState([]);
  const [selectedProductgroup, setSelectedProductgroup] = useState([]);


  useEffect(() => {
    dispatch( actions.fetchFilteredPenetrations(props.selectedSteps, [], [], []) ).then((res) => {
      setPenetrationRawData(res)
    });
  }, []);

  useEffect(() => {
    const penetrationIds = [selectedPenetration].map(x => x.value);
    const insulationIds = [selectedInsulation].map(x => x.value);
    const productgroupIds = [selectedProductgroup].map(x => x.value);

    dispatch( actions.fetchFilteredPenetrations(props.selectedSteps, penetrationIds, insulationIds, productgroupIds) ).then((res) => {
      const arr_penetrations = res.filter(x => x.type === 'pe').map( pen => {
        return {
          value: pen.id,
          label: t(pen.token)
        }
      }).sort((a, b) => a.label < b.label ? -1 : 1)

      setPenetrationOptions(arr_penetrations);


      const arr_insultations = res.filter(x => x.type === 'i').map( pen => {
        return {
          value: pen.id,
          label: t(pen.token)
        }
      }).sort((a, b) => a.label < b.label ? -1 : 1)

      setInsulationOptions(arr_insultations)


      const arr_products = res.filter(x => x.type === 'pr').map( pen => {
        console.log(currentLang());
        const lang_label = (pen.title[currentLang()] !== undefined && pen.title[currentLang()] !== "")? pen.title[currentLang()] : pen.title['de']

        return {
          value: pen.id,
          label: lang_label
        }
      }).sort((a, b) => a.label < b.label ? -1 : 1)

      setProductOptions(arr_products);


      const arr_product_systems = res.filter(x => x.type === 'ps').map( pen => { return pen.id })
      setFilteredProductSystemIds(arr_product_systems)

    });
  }, [penetrationRawData, selectedPenetration, selectedInsulation, selectedProductgroup]);


  const onChangePenetration = (e) => {
    const new_value = (e !== null) ? e : [];
    setSelectedPenetration(new_value);
  }

  const onChangeInsulation = (e) => {
    const new_value = (e !== null) ? e : [];
    setSelectedInsulation(new_value);
  }

  const onChangeProduct = (e) => {
    const new_value = (e !== null) ? e : [];
    setSelectedProductgroup(new_value);
  }


  const customSelectStyles = {
    groupHeading: () => ({
      color: "black",
      marginLeft: "10px",
      fontSize: "1.2em"
    }),

  }

  const wizard_finished_status = useSelector(state => actions.getReduxObjects(state.stats.wizard_finished_status));

  const dispatch = useDispatch();


  const getSelectedPenetrationValue = (selectedPenetration !== undefined && selectedPenetration !== null)? selectedPenetration.value : null;
  const getSelectedInsulationValue = (selectedInsulation !== undefined && selectedInsulation !== null)? selectedInsulation.value : null;
  const getSelectedProductgroupValue = (selectedProductgroup !== undefined && selectedProductgroup !== null)? selectedProductgroup.value : null;

  const onSelect = useCallback(
      (val) => dispatch( actions.wizardSelectProductSystem(val.id, val.penetration, val.insulation, val.productgroup) ).then( dispatch(actions.eventFinishProductSelector(wizard_finished_status))),
      [dispatch]
    )

  useEffect(() => {
    dispatch( actions.fetchProductsystems(props.selectedSteps) ).then((res) => setButtons(res));
  }, []);


   
  const productsystems = useSelector(state => actions.getReduxObjects(state.inventory.productSystems, buttons));

  const displayedProductSystems = (productsystems ) => {
    if (selectedPenetration != null) {
      return productsystems.filter(x => filteredProductSystemIds.includes(x.id) );
    } else {
      return productsystems
    }
  }

  const getImageUrl = (ps) => {
    let imageArray = ps.product_system_images.filter(function(element){ return element.installation_location === props.selectedSteps.location });
    let firstImage = (imageArray !== [])? imageArray[0] : undefined
    let image_url = (firstImage !== undefined)? firstImage.image_url : ""
    return image_url;
  }

  const displayedSeals = (allSeals) => {
    return allSeals.filter(x => x.display_ps_card === true);
  }

  return(

    <Aux>
      <WizardStandardHeader>
        <WizardNavigation />
      </WizardStandardHeader>

      <div className="row justify-content-center content-list-head">
        <div className="col-lg-11 col-xl-11">
          <WizardStandardSubHeader
            display={true}
            title={t('wizard.steps.product_system.title')}
            modalTitle={ t('wizard.steps.product_system.modaltitle') }
            modalTextToken={ 'wizard.steps.product_system.infotext' } />
        </div>
      </div>


      <div className="row justify-content-center" style={{paddingBottom: "20px"}}>
      <div className="col-lg-11 col-xl-11">
            <div className="row"> 

          <div className="col-lg-4 mb-3">

            <Controller
                control={control}
                name="penetrations"
                defaultValue={selectedPenetration}
                render= {({value, ref}) => (
                <Select
                  noOptionsMessage={() => t( 'wizard.steps.product_system.select_penetration.no_result' ) }
                  isClearable={true}
                  styles={customSelectStyles}
                  placeholder={ t( 'wizard.steps.product_system_item.select_penetration.placeholder' ) }
                  options={penetrationOptions}
                  value={selectedPenetration}
                  isDisabled={penetrationOptions.length === 0}
              
                  onChange={ (e) => onChangePenetration(e) }
                  inputRef={ref}
                />)}
              />  
          </div>



          <div className="col-lg-4 mb-3">
            <Controller
                control={control}
                name="insulations"
                defaultValue={selectedInsulation}
                render= {({value, ref}) => (
                <Select
                  noOptionsMessage={() => t( 'wizard.steps.product_system.select_insulation.no_result' ) }
                  isClearable={true}
                  styles={customSelectStyles}
                  placeholder={ t( 'wizard.steps.product_system_item.select_insulation.placeholder' ) }
                  options={insulationOptions}
                  value={selectedInsulation}
                  isDisabled={insulationOptions.length === 0}
                
                  onChange={ (e) => onChangeInsulation(e) }
                  inputRef={ref}
                />)}
              />  
          </div>


          <div className="col-lg-4 mb-3">
            <Controller
                control={control}
                name="products"
                defaultValue={selectedProductgroup}
                render= {({value, ref}) => (
                <Select
                  noOptionsMessage={() => t( 'wizard.steps.product_system.select_insulation.no_result' ) }
                  isClearable={true}
                  styles={customSelectStyles}
                  placeholder={ t( 'wizard.steps.product_system_item.select_product.placeholder' ) }
                  options={productOptions}
                  value={selectedProductgroup}
                  isDisabled={productOptions.length === 0 }
                
                  onChange={ (e) => onChangeProduct(e) }
                  inputRef={ref}
                />)}
              />  
          </div> 
          </div> </div>  


      </div> 


      {(width < 1024)?
        <div className="row justify-content-center">
          <div className="col-lg-12 col-xl-11">
            <div className="row">
              { displayedProductSystems(productsystems).map( (x) => <WizardButton 
              key={x.id} 
              value={ { id: x.id, penetration: getSelectedPenetrationValue, insulation: getSelectedInsulationValue, product: getSelectedProductgroupValue} } 
              title={x.title} 
              onClick={onSelect} 
              dividerEnabled={false} /> ) }
            </div>
          </div>
        </div>
      :
        <div className="row justify-content-center">

            <div className="col-lg-12 col-xl-11">
                  <div className="container-fluid" style={{padding: "0px"}} >
                      <div className="row col-centered">
                        { displayedProductSystems(productsystems).map( (x) => { return (<WizardProductSystemImageCard
                                                key={x.id}
                                                value={ { id: x.id, penetration: getSelectedPenetrationValue, insulation: getSelectedInsulationValue, product: getSelectedProductgroupValue} } 
                                                title={x.title}
                                                featureList={x.features}
                                                imageUrl={getImageUrl(x)}
                                                onClick={onSelect}
                                                seals={displayedSeals(x.seals)}
                                                dividerEnabled={false} />)}
                                               )
                        }
                      </div>
                  </div>
            </div>

        </div>
      }






    </Aux>


 );
};

export default wizardStepProductSystem;



// WEBPACK FOOTER //
// ./src/components/Wizard/Steps/WizardStepProductSystem.js